/* LMJE first-touch attribution (CC Growth Q3 attribution arm, 2026-07-02).
 * Captures utm_* / fbclid / igshid on the visitor's FIRST touch into a
 * first-party cookie (90 days), then appends the stored params to every link
 * into the Circle checkout (laras-mah-jong-edit.circle.so/checkout/...).
 * Circle persists the checkout URL's query string into Stripe subscription
 * metadata (paywall_url), which cc-tracker reads as real attribution.
 * Never overrides a link that is already UTM-tagged. No PII stored.
 */
(function () {
  var PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "fbclid", "igshid", "igsh"];
  var COOKIE = "lmje_attr";

  function currentParams() {
    var q, out = {}, found = false, i, v;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return null; }
    for (i = 0; i < PARAMS.length; i++) {
      v = q.get(PARAMS[i]);
      if (v) { out[PARAMS[i]] = v; found = true; }
    }
    return found ? out : null;
  }

  function readCookie() {
    try {
      var m = document.cookie.match(/(?:^|; )lmje_attr=([^;]*)/);
      return m ? JSON.parse(decodeURIComponent(m[1])) : null;
    } catch (e) { return null; }
  }

  function writeCookie(obj) {
    try {
      var v = encodeURIComponent(JSON.stringify(obj));
      var domain = window.location.hostname.indexOf("larasmahjongedit.com") !== -1 ? "; domain=.larasmahjongedit.com" : "";
      document.cookie = COOKIE + "=" + v + "; max-age=7776000; path=/" + domain + "; SameSite=Lax; Secure";
    } catch (e) {}
  }

  var stored = readCookie();
  var cur = currentParams();

  if (!stored) {
    if (cur) {
      cur._ts = new Date().toISOString().slice(0, 10);
      writeCookie(cur);
      stored = cur;
    } else if (document.referrer) {
      // Referrer-only first touch (e.g. untagged IG profile tap): keep the host.
      try {
        var rh = new URL(document.referrer).hostname;
        if (rh && rh.indexOf("larasmahjongedit.com") === -1 && rh.indexOf("myshopify.com") === -1) {
          stored = { _ref: rh, _ts: new Date().toISOString().slice(0, 10) };
          writeCookie(stored);
        }
      } catch (e) {}
    }
  }

  function decorate() {
    if (!stored) return;
    var links = document.querySelectorAll('a[href*="circle.so/checkout"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      try {
        var u = new URL(a.href);
        var qs = u.searchParams;
        if (qs.get("utm_source")) continue; // already tagged upstream: respect it
        var changed = false;
        for (var k in stored) {
          if (stored.hasOwnProperty(k) && k.charAt(0) !== "_") { qs.set(k, stored[k]); changed = true; }
        }
        if (!qs.get("utm_source") && stored._ref) { qs.set("utm_source", "ref-" + stored._ref); changed = true; }
        if (qs.get("utm_source") && !qs.get("utm_medium")) { qs.set("utm_medium", "site"); changed = true; }
        if (qs.get("utm_source") && !qs.get("utm_campaign")) { qs.set("utm_campaign", "first-touch-" + (stored._ts || "na")); changed = true; }
        if (changed) a.href = u.toString();
      } catch (e) {}
    }
  }

  decorate();
  if (window.MutationObserver) {
    new MutationObserver(function () { decorate(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
